import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux'; 
import MenuSideWebCMS from './side_menu_web_cms.js';
import { API_BASE_URL } from "../utils/endpoints";

const data = new FormData();
  class EditAds extends React.Component {


    state = {
       title: '',
       link: '',
       image: '',

    }

    


handleChange = event =>
{
      this.setState({ title: event.target.value});
}


handleChangelink =event =>
{
  this.setState({ link: event.target.value});
}

handleChangeimage = event =>
{
      this.setState({ image: event.target.value});
      data.append('file', event.target.files[0]);

}

  componentDidMount(){
    var token=reactLocalStorage.get('accessToken');
    var id=reactLocalStorage.get('id_adv');
    
     var ip=API_BASE_URL;
     var s2 = "localhost:3000";
     var apiBaseUrl;
     if(ip.includes(s2))
     {
      apiBaseUrl =API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
     }
     else
     {
      apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/getAllAdv";
     }
     var headers = {'Content-Type': 'application/json', 'token' :token }
     axios.get(apiBaseUrl,{headers: headers})
         .then(res => {
           const persons = res.data.result.advertisments;
           var i;
           if(persons != undefined)
           {
             for(i=0;i<persons.length;i++){
               if(persons[i].id === id)
               {
               
                this.setState({ title:persons[i].advertisment_title });
                this.setState({ link:persons[i].advertisment_url });
                this.setState({ image:persons[i].advertisment__src });
               }
             }

           }
           
         })

  }
  back=()=>
  {
    window.location="Adds";

  }
handleSubmit = event =>
{
      event.preventDefault();
      var token=reactLocalStorage.get('accessToken');
      var test= new Blob([JSON.stringify({  
      'advertisment_title': this.state.title,
      'advertisment_url': this.state.link,
      'id':reactLocalStorage.get('id_adv')
      })] ,{type : "application/json"});
      data.append('object', test);
     
      
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/advertisments/manageAdv";
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/manageAdv";
      }
     
      axios.post(apiBaseUrl,data,{headers: { 'Content-Type': 'multipart/form-data',
        'token':token}}).then(function (response)
      {

      if(response.status === 200)
      {
         
      window.location="Adds";


      }
      else if(response.status === 204){
      console.log("Something wrong");


      }
      else{
      console.log("Something wrong");
    

      }
      })
      .catch(function (error) {
      console.log(error);
      });
    }


  render() {
  return (
    <div className="big_div">
    <MenuSideWebCMS/>
    <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit}>
                <p className="h4 text-center py-4 text_style">{i18n.t('Edit_Advertisings.label')}</p>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                {i18n.t('Title_of_Advertising.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="title"
                  onChange={this.handleChange}
                  defaultValue={this.state.title}
                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                {i18n.t('Link_of_Advertising.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="link"
                  onChange={this.handleChangelink}
                  defaultValue={this.state.link}
                />
              <br/>
                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                {i18n.t('Advertising_Image.label')}
                  </label>
                <br />
                <input
                  type="file"
                  id="defaultFormCardEmailEx"
                  name="image"
                  onChange={this.handleChangeimage}
                  defaultValue={this.state.image}
                />

                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_green">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}
                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_green">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div>  </div>  </div>
  );
}
};
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditAds);
